import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../assets/MAIN.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-custom shadow-sm py-3">
      <div className="container d-flex align-items-center justify-content-between">
        {/* Logo links back to home */}
        <NavLink to="/" className="logo-wrapper" onClick={closeMenu}>
          <img
            id="logo"
            src={Logo}
            alt="Speech Innovation NC Logo"
          />
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navMenu"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div
          className={`collapse navbar-collapse justify-content-end ${isOpen ? 'show' : ''}`}
          id="navMenu"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink to="/" className="nav-link" onClick={closeMenu}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className="nav-link" onClick={closeMenu}>
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/mission" className="nav-link" onClick={closeMenu}>
                Mission
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/team" className="nav-link" onClick={closeMenu}>
                Team
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/services" className="nav-link" onClick={closeMenu}>
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className="btn btn-primary ms-lg-3" onClick={closeMenu}>
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
